import { get } from 'lodash'
import StripePlan from "models/data/stripe/StripePlan";
import StripeCustomer from "models/data/stripe/StripeCustomer";
import StripeSubscription from "models/data/stripe/StripeSubscription";
import prisma from 'libraries/prisma/client'
import uuidv4 from "uuid/v4";

class PrismaUser {
	static default = {
		id: "",
		firebase_id: "",
		email: "",
		first_name: "",
		last_name: "",
		stripe_customer_id: "",
		stripe_plan_id: "",
		stripe_subscription_ends_at: "",
		stripe_subscription_id: "",
		referral_code: "",
		referrer: {},
		app_store_token: '',
		updatedAt: "2019-01-01",
		createdAt: "2019-01-01"
	};

	static id = prismaUser => get(prismaUser, "id", PrismaUser.default.id);

	static firebaseId = prismaUser => get(prismaUser, "firebase_id", PrismaUser.default.firebase_id);

	static firstName = prismaUser => get(prismaUser, "first_name", PrismaUser.default.first_name);

	static lastName = prismaUser => get(prismaUser, "last_name", PrismaUser.default.last_name);

	static stripeCustomerId = prismaUser =>
		get(prismaUser, "stripe_customer_id", PrismaUser.default.stripe_customer_id);

	static stripePlanId = prismaUser => get(prismaUser, "stripe_plan_id", PrismaUser.default.stripe_plan_id);

	static stripeSubscriptionEndsAt = prismaUser =>
		get(prismaUser, "stripe_subscription_ends_at", PrismaUser.default.stripe_subscription_ends_at);

	static stripeSubscriptionId = prismaUser =>
		get(prismaUser, "stripe_subscription_id", PrismaUser.default.stripe_subscription_id);

	static email = prismaUser => get(prismaUser, "email", PrismaUser.default.email);

	static referralCode = prismaUser => get(prismaUser, "referral_code", PrismaUser.default.referral_code);

	static appStoreToken = prismaUser => get(prismaUser, "app_store_token", PrismaUser.default.app_store_token);

	static async fetch(firebaseId) {
        let prismaUser = null
        prismaUser = await prisma.user({ firebase_id: firebaseId });
		return prismaUser;
    }

    static async create(
        firebaseId: string,
        firstName: string,
        lastName: string,
        email: string
    ) {
        const prismaUser = await prisma.createUser({
            firebase_id: firebaseId,
            first_name: firstName,
            last_name: lastName,
            email,
            referral_code: uuidv4()
        })

        return prismaUser
    }

	static async startOrUpdateSubscription(
		firebaseId: string,
		email: string,
		stripePlan: string,
		stripePaymentMethodId: string,
		stripeCouponId: string,
		isTrial: boolean
	) {
        const stripePlanId = StripePlan.getPlanId(stripePlan);
        const stripeCustomer = await StripeCustomer.createOrUpdate(email, stripePaymentMethodId);
        const stripeCustomerId = StripeCustomer.id(stripeCustomer);
        const stripeSubscription = await StripeSubscription.createOrUpdate(
			stripeCustomerId,
			stripePlanId,
			stripeCouponId,
			isTrial
        );

		const updatedPrismaUser = await PrismaUser.updateSubscriptionInformation(
			firebaseId,
			stripePlanId,
			stripeSubscription,
			stripeCustomer
        );
        return updatedPrismaUser
	}

		static async startOneTimeSubscription(
			firebaseId: string,
			email: string,
			stripePlan: string,
			stripePaymentMethodId: string,
			stripeCouponId: string,
			isTrial: boolean
		) {
            const stripePlanId = StripePlan.getPlanId(stripePlan);
	        const stripeCustomer = await StripeCustomer.createOrUpdate(email, stripePaymentMethodId);
            const stripeCustomerId = StripeCustomer.id(stripeCustomer);
            const stripeSubscription = await StripeSubscription.createOneTime(
                    stripeCustomerId,
                    stripePlanId,
                    stripeCouponId,
                    isTrial
                );

			const updatedPrismaUser = await PrismaUser.updateSubscriptionInformation(
				firebaseId,
				stripePlanId,
				stripeSubscription,
				stripeCustomer
	        );
	        return updatedPrismaUser
		}



	static async updateSubscriptionInformation(
		firebaseId: string,
		stripePlanId: string,
		stripeSubscription: any,
		stripeCustomer: any
	) {
		const updatedPrismaUser = await prisma.updateUser({
			where: { firebase_id: firebaseId },
			data: {
				email: StripeCustomer.email(stripeCustomer),
				stripe_customer_id: StripeCustomer.id(stripeCustomer),
				stripe_subscription_id: StripeSubscription.id(stripeSubscription),
				stripe_subscription_ends_at: StripeSubscription.endsAt(stripeSubscription),
				stripe_plan_id: stripePlanId
			}
        });
        return updatedPrismaUser
	}
}

export default PrismaUser
